import React from 'react';
interface Props {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  dark = false,
  className = ''
}: Props) {
  return <div className={`mx-auto max-w-2xl text-center ${className}`} data-id="element-178" data-mp="7gyz19ji1uqp">
      {eyebrow && <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue" data-id="element-179" data-mp="ceqntuoul0qo">
          {eyebrow}
        </p>}
      <h2 className={`font-heading text-3xl font-extrabold tracking-tight sm:text-4xl ${dark ? 'text-white' : 'text-navy-900'}`} data-id="element-180" data-mp="152wboqb775uq">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed ${dark ? 'text-white/70' : 'text-slate-600'}`} data-id="element-181" data-mp="v4gkyog31ylr">
          {subtitle}
        </p>}
    </div>;
}